import { c as _c } from "react/compiler-runtime";
import { ApplyNowButton } from 'src/features/product-card/ApplyNowButton';
import { useReviewContext } from '../../../Context';
export default function ReviewProductCardApplyNowButton() {
  const $ = _c(15);
  const {
    marketplaceEntity
  } = useReviewContext();
  const {
    details: t0,
    institution: t1,
    name,
    displayName,
    ctaAnalytics
  } = marketplaceEntity;
  const {
    applyLink,
    applyPhoneNumber,
    isActive,
    isMonetizing,
    reviewLink,
    versionId
  } = t0;
  const {
    name: institutionName
  } = t1;
  let t2;
  if ($[0] !== ctaAnalytics.section) {
    t2 = {
      ...ctaAnalytics.section,
      name: "review_product_card_sticky"
    };
    $[0] = ctaAnalytics.section;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== ctaAnalytics || $[3] !== t2) {
    t3 = {
      ...ctaAnalytics,
      section: t2,
      linkType: "APPLY_NOW_BUTTON"
    };
    $[2] = ctaAnalytics;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = displayName || name;
  let t5;
  if ($[5] !== applyLink || $[6] !== applyPhoneNumber || $[7] !== institutionName || $[8] !== isActive || $[9] !== isMonetizing || $[10] !== reviewLink || $[11] !== t3 || $[12] !== t4 || $[13] !== versionId) {
    t5 = <ApplyNowButton analytics={t3} id="sidebar-product-card-apply-now" isActive={isActive} isMonetizing={isMonetizing} applyLink={applyLink} reviewLink={reviewLink} applyPhoneNumber={applyPhoneNumber} institutionName={institutionName} ctaType="APPLY_NOW_BUTTON" versionId={versionId} linkSx={_temp} name={t4} />;
    $[5] = applyLink;
    $[6] = applyPhoneNumber;
    $[7] = institutionName;
    $[8] = isActive;
    $[9] = isMonetizing;
    $[10] = reviewLink;
    $[11] = t3;
    $[12] = t4;
    $[13] = versionId;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(t0) {
  const {
    palette: t1
  } = t0;
  const {
    primary
  } = t1;
  return {
    maxHeight: "2.5rem",
    "&:hover": {
      backgroundColor: primary.dark
    }
  };
}